<template>
  <div id="weeklyReportHistory">
		<el-dialog
			title="Weekly Report History"
			width="1100px"
			top="5vh"
			:visible.sync="historyDialog"
			:close-on-click-modal="false"
		>
			<el-table :data="tableData" size="small" border v-loading="tableLoading" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column label="No." prop="number" align="center" width="50">
					<template slot-scope="scope">
						{{ (currentPage - 1) * pageSize + scope.$index + 1 }}
					</template>
				</el-table-column>
        <el-table-column prop="createDate" label="Recording Date" align="center" width="130">
					<template v-slot="scope">
						{{ scope.row.createDate ? moment(scope.row.createDate).format('YYYY-MM-DD') : ''}}
					</template>
				</el-table-column>
        <el-table-column prop="projectOverview" label="Basic Information of Project" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="overallProjectProgress" label="Overall Project Progress" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" width="90">
					<template slot-scope="scope">
						<el-button type="primary" size="small" @click="openDetail(scope.row)">Detail</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"

				>
				</el-pagination>
			</div>
		</el-dialog>
		<el-dialog
			title="Weekly Report"
			width="1100px"
			top="5vh"
			:visible.sync="historyWeeklyDialog"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@closed="closeDialog"
		>
			<history-detail ref="historyWeekly" :historyWeeklyData="historyWeeklyData" />
		</el-dialog>
  </div>
</template>
<script>
  import {_debounce} from '@/utils/selectAPI'
  import * as validate from '@/utils/validate'
	import moment from 'moment'
	import axios from 'axios'
	import historyDetail from './historyDetail.vue'
  export default {
    name: 'weeklyReportHistory',
		components: {
			historyDetail,
		},
    created () {
			// this.handleSearch();
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
		},
    data () {
      return {
				moment,
				historyDialog: false,
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				historyWeeklyDialog: false,
				historyWeeklyData: {},
      }
    },
    methods: {
			handleSearch() {
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}weeklyReportCustomer/getHistoryReport`
				let params = {
					majorProjectId: this.id,
					islhToken: sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
							const list = []
							res.data && res.data.forEach(item => {
								const detailinfo = item.reportText;
								list.push({
									...detailinfo,
									...item,
								})
							});
						this.tableData = list;
						this.totalCount = list.length;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			openDetail(row) {
				this.historyWeeklyDialog = true;
				const weeklytimer = setTimeout(() => {
					this.$refs.historyWeekly.getWeeklyInfo();
					clearTimeout(weeklytimer)
				}, 200);
				this.historyWeeklyData = {
					...row,
				};
			},
			closeDialog() {
				this.historyWeeklyDialog = false;
				this.historyWeeklyData = {};
			}
		},
  }
</script>
<style lang="less" scoped>
#weeklyReportHistory {
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/weeklyReportCus/history.vue